import type { ExtraPackageContentItem } from '../api/types'
import type { OneTimePackCardDecoration } from './oneTimeCardData'

/**
 * Splits a SKU's `packageContents` into renderable regular items (kaisuuken,
 * etc.) and decoration items (which require an async `useDecoration(code)`
 * lookup to render their label + preview).
 */
export function partitionPackageContents(items: ExtraPackageContentItem[]): {
  regular: ExtraPackageContentItem[]
  decorations: OneTimePackCardDecoration[]
} {
  const regular: ExtraPackageContentItem[] = []
  const decorations: OneTimePackCardDecoration[] = []
  for (const item of items) {
    if (item.kind === 'decoration') {
      if (item.code)
        decorations.push({ code: item.code, quantity: item.quantity ?? 1 })
    } else {
      regular.push(item)
    }
  }
  return { regular, decorations }
}
